import React from 'react';
import type { OrderStatusMobileSheetProps } from './types';
import OrderStatusUpdateTable from './OrderStatusUpdateTable';

const OrderStatusMobileSheet: React.FC<OrderStatusMobileSheetProps> = ({
  isOpen,
  onClose,
  data,
  isLoading,
  brand,
}) => {
  if (!isOpen) return null;

  const emailRecipientsText = data?.emailRecipients?.join(', ') || '';

  return (
    <div className="fixed inset-0 z-50 flex flex-col">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/50"
        onClick={onClose}
        aria-hidden="true"
      />

      {/* Bottom sheet */}
      <div
        className="relative mt-auto bg-white rounded-t-2xl shadow-xl max-h-[80vh] flex flex-col"
        role="dialog"
        aria-modal="true"
        aria-labelledby="status-sheet-title"
      >
        {/* Handle */}
        <div className="flex justify-center py-2">
          <div
            className="w-10 h-1 rounded-full"
            style={{ backgroundColor: brand.colors.border }}
          />
        </div>

        {/* Header */}
        <div
          className="px-4 py-3 flex items-center justify-between border-b"
          style={{ borderColor: brand.colors.border }}
        >
          <h2
            id="status-sheet-title"
            className="text-lg font-semibold"
            style={{ color: brand.colors.secondary }}
          >
            Status Updates
          </h2>
          <button
            onClick={onClose}
            className="p-2 rounded-lg hover:bg-gray-100 transition-colors"
            aria-label="Close"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-auto p-4">
          {isLoading ? (
            <div className="flex items-center justify-center py-12">
              <div
                className="w-8 h-8 border-2 border-t-transparent rounded-full animate-spin"
                style={{ borderColor: brand.colors.primary, borderTopColor: 'transparent' }}
              />
            </div>
          ) : data ? (
            <>
              {/* Action bar */}
              <div className="mb-4">
                <button
                  className="w-full px-3 py-2 text-sm font-medium rounded border"
                  style={{
                    borderColor: brand.colors.primary,
                    color: brand.colors.link,
                    backgroundColor: 'white',
                  }}
                >
                  Add Status Update
                </button>
                {emailRecipientsText && (
                  <p
                    className="mt-2 text-xs text-center"
                    style={{ color: brand.colors.textLight }}
                  >
                    Email will be sent to: <span style={{ color: brand.colors.text }}>{emailRecipientsText}</span>
                  </p>
                )}
              </div>

              {/* Table (scrollable) */}
              <div className="-mx-4">
                <OrderStatusUpdateTable updates={data.updates} brand={brand} />
              </div>
            </>
          ) : (
            <div
              className="py-8 text-center text-sm"
              style={{ color: brand.colors.textLight }}
            >
              No data available
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default OrderStatusMobileSheet;
